import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { GeneralHelper } from 'src/app/helpers/general-helper';
import Employee from 'src/app/model/product/employee';
import { Project } from 'src/app/model/project/project';
import { EmployeeChoicesService } from 'src/app/services/employee-choices.service';
import { SetProjectNeedsDesignControllerRequestService } from './set-project-needs-design-controller-request.service';
import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';
import { BaseProject } from 'src/app/model/project/base-project';

@Component({
  selector: 'ip-board-design-dialog',
  templateUrl: './ip-board-design-dialog.component.html',
  styleUrls: ['./ip-board-design-dialog.component.scss']
})
export class IPBoardDesignDialogComponent extends SubscriptionBasedComponent
  implements OnInit {
  @Input()
  project: Project;
  @Input()
  baseProject: BaseProject;
  @Output()
  close = new EventEmitter<boolean>();

  designerChoices: Employee[] = [];

  selectedDesigner: Employee;
  selectedDeadline: Date;
  needsDesignDescription: string;

  submitting: boolean = false;

  constructor(
    private employeeChoicesService: EmployeeChoicesService,
    private setProjectNeedsDesignControllerRequestService: SetProjectNeedsDesignControllerRequestService
  ) {
    super();
  }

  ngOnInit(): void {
    if (!CollectionHelper.isPopulated(this.project.products)) {
      throw new Error('Project heeft geen producten');
    }

    this.initializeFromProduct();

    this.addSubscription(
      this.employeeChoicesService.getDesignerChoicesSubscribable(),
      (designers: Employee[]) => {
        this.designerChoices = designers;
      }
    );
  }

  private initializeFromProduct(): void {
    this.selectedDesigner = this.project.products[0].designer;
    this.selectedDeadline = this.project.products[0].designByDate;
    this.needsDesignDescription = this.project.products[0].needsDesignDescription;
  }

  needsDesignDescriptionChanged(value: string): void {
    this.needsDesignDescription = value;
  }

  closeDialog(): void {
    this.close.emit(false);
  }

  async confirmNeedsDesign(): Promise<void> {
    this.submitting = true;
    try {
      await this.setProjectNeedsDesignControllerRequestService.setProjectNeedsDesign(
        this.project.id,
        this.selectedDesigner == null ? null : this.selectedDesigner.id,
        this.selectedDeadline,
        this.needsDesignDescription
      );
      this.project.products.forEach(p => {
        p.needsDesign = true;
        p.designer = this.selectedDesigner;
        p.designByDate = this.selectedDeadline;
        p.needsDesignDescription = this.needsDesignDescription;
        p.designSentToCustomer = false;
        p.designSentLog = null;
        p.designApprovalRegistration = null;
        p.customerApproves = false;
        p.customerApprovalFeedback = null;
        p.designFinished = false;
      });
      this.baseProject.currentDesignDate = this.selectedDeadline;
      this.close.emit(true);
    } finally {
      this.submitting = false;
    }
  }

  compareEntities(o1: any, o2: any): boolean {
    return GeneralHelper.compareEntities(o1, o2);
  }
}
